import React from 'react';
import { Spinner } from '@routific/hive/v5';
import './Loading.css';

interface LoadingProps {
  contained?: boolean;
}

const Loading: React.FunctionComponent<LoadingProps> = ({ contained = false }) => (
  <div className={`LoadingContainer${contained ? ' LoadingContainer--contained' : ''}`}>
    <Spinner />
  </div>
);
export default Loading;
